<template>
  <v-footer>
    <v-card-text class="mx-auto py-2 black--text text-center">
      <div>
        &copy; SEIKO EPSON Corporation 2022 - {{ new Date().getFullYear() }} All rights reserved.
        <div class="text-right">{{ ver }}</div>
      </div>
    </v-card-text>
  </v-footer>
</template>

<script>
export default {
  name: 'Footer',

  computed: {
    ver: {
      get() {
        return 'Ver: ' + process.env.VUE_APP_FRONTEND_VER
      },
    },
  },
}
</script>
